import React, { useState } from 'react';

import { Box, Checkbox, FormField, Heading, Label, Modal, Text } from '@zillow/constellation-10';

import ModalFooter from './ModalFooter';

export type ConfirmationModalProps = {
  textContent: JSX.Element | string;
  submitButtonTitle?: string;
  cancelButtonTitle?: string;
  onSubmit: () => void;
  onCancel?: () => void;
  cancelConditions?: string;
  onClose?: () => void;
  header: string;
};

export const ConfirmationModal = ({
  submitButtonTitle = 'Confirm',
  cancelButtonTitle = 'Cancel',
  textContent,
  onSubmit,
  onCancel,
  cancelConditions = '',
  header,
  onClose,
}: ConfirmationModalProps) => {
  const [acceptedCancelConditions, setAcceptedCancelConditions] = useState(false);

  return (
    <Modal
      header={
        <Heading level={6} css={{ textAlign: 'center' }}>
          {header}
        </Heading>
      }
      open={true}
      onOpenChange={(isOpen) => {
        if (!isOpen && onClose) {
          onClose();
        }
      }}
      size={{ base: 'fullScreen', md: 'md' }}
      body={
        <>
          {textContent && <Text>{textContent}</Text>}
          {cancelConditions && (
            <Box css={{ marginBlock: '400' }}>
              <Text>{cancelConditions}</Text>
              <FormField>
                <Checkbox
                  name="LabeledControl-checkbox-cancel-accept"
                  checked={acceptedCancelConditions}
                  onChange={() => setAcceptedCancelConditions((acceptedCancelConditions) => !acceptedCancelConditions)}
                >
                  <Label>Yes, I accept the Terms and Conditions</Label>
                </Checkbox>
              </FormField>
            </Box>
          )}
        </>
      }
      footer={
        <ModalFooter
          submitText={submitButtonTitle}
          onSubmit={onSubmit}
          onCancel={onCancel || onClose}
          cancelText={cancelButtonTitle}
          isSubmitting={cancelConditions ? !acceptedCancelConditions : false}
        />
      }
    />
  );
};

export default ConfirmationModal;
